import React from 'react';
import AnsibleHostDetail from './AnsibleHostDetail';

const WrappedAnsibleHostDetail = props => <AnsibleHostDetail {...props} />;

export default WrappedAnsibleHostDetail;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/components/AnsibleHostDetail/index.js